import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useState } from 'react';
import Scrollspy from 'react-scrollspy';

import { NumberBox, TextArea, TextBox, DateTimeBox } from '../../shared/controls/form';
import Select from 'react-select';

const validationSchema = Yup.object().shape({
  businessType: Yup.string().required('Business Type is required'),
  industry: Yup.string().required('Industry is required'),
});

const ViewCalls = ({ handleFormSubmit, leadSourceDropdown, leadData }) => {
  const [formData, setFormData] = useState(leadData);
  const [errormsg, setErrorMsg] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({});
  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    const convertedValue = value;
    setFormData({
      ...formData,
      [name]: convertedValue,
    });
  };
  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };
  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));

    const updatedFormData = {
      ...formData,
      [name]: selectedId,
      [`${name}Name`]: selectedValue,
    };
    if (name === 'revenueTypeId') {
      setFormData({
        ...formData,
        revenueTypeId: selectedId,
        revenueType: selectedValue,
      });
    } else if (name === 'leadSourceId') {
      setFormData({
        ...formData,
        leadSourceId: selectedId,
        leadSource: selectedValue,
      });
    } else if (name === 'industryId') {
      setFormData({
        ...formData,
        industryId: selectedId,
        industry: selectedValue,
      });
    }
  };
  const handleSubmit = async (formData) => {
    try {
      await validationSchema.validate(formData, { abortEarly: false });
      handleFormSubmit(formData);
    } catch (error) {
      const fieldErrors = {};
      error.inner.forEach((err) => {
        fieldErrors[err.path] = err.message;
      });
      setErrorMsg(fieldErrors);
      console.error('Validation Error:', fieldErrors);
    }
  };

  return (
    <div className="ViewLeadPageOuter">
      <div className="viewHeader">
        <div className="userProfileBlock">
          <div className="userimg">
            <img src="/assets/images/logo-img.png" alt="" title=""></img>
          </div>
          <div>
            <p>John Doe</p>
            <div className="flex-div tag">
              <img src="/assets/images/tag.png" alt="" title="" className="me-2"></img>
              <small>Add Tags</small>
            </div>
          </div>
        </div>

        <div className="rightAction">
          <button className="btn btn-outline-primary actbtn">Send Email</button>
          <button className="btn btn-outline-primary  ms-3">Convert</button>
          <button className="btn btn-outline-primary ms-3">Edit</button>
        </div>
      </div>

      <div className="viewFormContainer">
        <div className="leftBlock">
          <h2>Related List</h2>

          <ul>
            <Scrollspy
              items={[
                'notes',
                'attachments',
                'campaigns',
                'openActivities',
                'closedActivities',
                'invitedMeetings',
                'emails',
              ]}
              currentClassName="activeList"
            >
              <li>
                <a href="#notes" title="Notes">
                  Notes
                </a>
              </li>
              <li>
                <a href="#attachments" title="Attachments">
                  Attachments
                </a>
              </li>
              <li>
                <a href="#campaigns" title="Campaigns">
                  Campaigns
                </a>
              </li>
              <li>
                <a href="#openActivities" title="Open Activities">
                  Open Activities
                </a>
              </li>
              <li>
                <a href="#closedActivities" title="Closed Activities">
                  Closed Activities
                </a>
              </li>
              <li>
                <a href="#invitedMeetings" title="Invited Meetings">
                  Invited Meetings
                </a>
              </li>
              <li>
                <a href="#emails" title="Email">
                  Email
                </a>
              </li>
            </Scrollspy>
          </ul>
        </div>

        <div className="rightBlock">
          <div className="viewTabs">
            <ul className="nav nav-tabs justify-content-start">
              <li className="nav-item">
                <a className="nav-link active" href="#overview" data-bs-toggle="tab">
                  Overview
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#timeline" data-bs-toggle="tab">
                  Timeline
                </a>
              </li>
            </ul>
          </div>
          <div className="addlead_container">
            <Formik
              initialValues={formData}
              onSubmit={(values) => handleSubmit(values)}
              validationSchema={validationSchema}
            >
              <Form>
                <div className="tab-content">
                  <div className="tab-pane fade show active" id="overview">
                    <div className="accordion " id="overviewBlock">
                      <div className="accordion-item addleadcard">
                        <h2 className="accordion-header addlead-header" id="headingOne">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            Overview
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#overviewBlock"
                        >
                          <div className="addleadcard">
                            <div className="addlead-header">
                              <label htmlFor="">Call Information</label>
                            </div>
                            <div className="leadcontent">
                              <>
                                <div className="row">
                                  <div className="col-12 col-md-3">
                                    <div className="input-container">
                                      <TextBox
                                        isRequired={true}
                                        label={'Call To'}
                                        name={'callTo'}
                                        placeholder={'Call To'}
                                        handleChange={handleChangeForm}
                                        maxLength={250}
                                        errormsg={errormsg.callTo}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-3">
                                    <div className="input-container">
                                      <label htmlFor="leadSource">Related To</label>
                                      <Select
                                        value={selectedOptions.accountOwner}
                                        onChange={(selectedOption) =>
                                          handleChange(selectedOption, 'relatedTo')
                                        }
                                        options={leadSourceDropdown?.map((data) => ({
                                          value: data.id,
                                          label: data.status,
                                        }))}
                                        disabled={'relatedTo'}
                                        placeholder={'Related To'}
                                        styles={{
                                          container: (base) => ({
                                            ...base,
                                            width: '100%',
                                          }),
                                          control: (base) => ({
                                            ...base,
                                            borderColor: errormsg.relatedTo
                                              ? 'red'
                                              : base.borderColor,
                                          }),
                                        }}
                                      />
                                      {errormsg.accountOwner && (
                                        <div className="error-message">{errormsg.relatedTo}</div>
                                      )}
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-3">
                                    <div className="input-container">
                                      <TextBox
                                        isRequired={true}
                                        label={'Call Type'}
                                        name={'calllType'}
                                        placeholder={'Call Type'}
                                        handleChange={handleChangeForm}
                                        maxLength={250}
                                        errormsg={errormsg.callType}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-3">
                                    <div className="input-container">
                                      <TextBox
                                        isRequired={false}
                                        label={'Outgoing Call Status'}
                                        name={'outgoingCallStatus'}
                                        placeholder={'Outgoing Call Status'}
                                        handleChange={handleChangeForm}
                                        maxLength={250}
                                        errormsg={errormsg.outgoingCallStatus}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-3">
                                    <div className="input-container">
                                      <DateTimeBox
                                        isRequired={true}
                                        label={'Call Start Time'}
                                        name={'callStartTime'}
                                        placeholder={'MM/DD/YYYY'}
                                        handleChange={handleChangeForm}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-3">
                                    <div className="input-container">
                                      <TextBox
                                        isRequired={false}
                                        label={'Call Owner'}
                                        name={'callowner'}
                                        placeholder={'Call Owner'}
                                        handleChange={handleChangeForm}
                                        maxLength={250}
                                        errormsg={errormsg.callOwner}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <div className="input-container">
                                      <TextBox
                                        isRequired={false}
                                        label={'Subject'}
                                        name={'subject'}
                                        placeholder={'Subject'}
                                        handleChange={handleChangeForm}
                                        maxLength={250}
                                        errormsg={errormsg.subject}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-3">
                                    <div className="input-container">
                                      <TextBox
                                        isRequired={false}
                                        label={'Reminder'}
                                        name={'reminder'}
                                        placeholder={'-'}
                                        handleChange={handleChangeForm}
                                        maxLength={250}
                                        errormsg={errormsg.reminder}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </>
                            </div>
                            <div className="addlead-header">
                              <label htmlFor="">Purpose of Outgoing Call</label>
                            </div>
                            <div className="leadcontent">
                              <>
                                <div className="row">
                                  <div className="col-12 col-md-3">
                                    <div className="input-container">
                                      <label htmlFor="leadSource">Call Purpose</label>
                                      <Select
                                        value={selectedOptions.accountOwner}
                                        onChange={(selectedOption) =>
                                          handleChange(selectedOption, 'callPurpose')
                                        }
                                        options={leadSourceDropdown?.map((data) => ({
                                          value: data.id,
                                          label: data.status,
                                        }))}
                                        disabled={'type'}
                                        placeholder={'Select'}
                                        styles={{
                                          container: (base) => ({
                                            ...base,
                                            width: '100%',
                                          }),
                                          control: (base) => ({
                                            ...base,
                                            borderColor: errormsg.accountOwner
                                              ? 'red'
                                              : base.borderColor,
                                          }),
                                        }}
                                      />
                                      {errormsg.accountOwner && (
                                        <div className="error-message">{errormsg.callPurpose}</div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-3">
                                    <div className="input-container">
                                      <TextBox
                                        isRequired={false}
                                        label={'Call Agenda'}
                                        name={'callAgenda'}
                                        placeholder={'-'}
                                        handleChange={handleChangeForm}
                                        maxLength={250}
                                        errormsg={errormsg.callAgenda}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-3">
                                    <div className="input-container">
                                      <TextBox
                                        label={'Created By'}
                                        name={'createdBy'}
                                        placeholder={'Created By'}
                                        handleChange={handleChangeForm}
                                        errormsg={errormsg.createdBy}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-3">
                                    <div className="input-container">
                                      <NumberBox
                                        label={'Modified By'}
                                        name={'modifiedBy'}
                                        placeholder={'Modified By'}
                                        handleChange={handleChangeForm}
                                        errormsg={errormsg.modifiedBy}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div id="notes" className="scrollTo"></div>
                    <div className="addleadcard">
                      <div className="addlead-header">
                        <label htmlFor="">Notes</label>
                      </div>
                      <div className="leadcontent">
                        <>
                          <div className="row">
                            <div className="col-12 col-md-12">
                              <div className="userImg">
                                <img src="/assets/images/userImage.png" alt="" />
                                <span>Notes Name</span>
                              </div>
                              <div className="actionRow">
                                <div className="leadRow">
                                  Lead - <span className="userName">John Doe</span>
                                </div>
                                <div className="addNote">
                                  {' '}
                                  Add Note -{' '}
                                  <span className="submitedBy">Oct 2 by Emilia Gram.</span>{' '}
                                </div>
                                <div className="actionButton">
                                  <img
                                    src="/assets/images/editNotes.png"
                                    alt="Edit Notes"
                                    width="14px"
                                  />
                                  <img
                                    src="/assets/images/deleteNotes.png"
                                    alt="Delete Notes"
                                    width="18px"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-md-12">
                              <div className="input-container customTextA">
                                <TextArea
                                  name={'technologyDetails'}
                                  placeholder={'Add a note...'}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg.technologyDetails}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>
                    <div id="attachments" className="scrollTo"></div>
                    <div className="addleadcard">
                      <div className="addlead-header">
                        <label htmlFor="">Attachments</label>
                        <button className="btn btn-outline-primary attBtn">
                          <img
                            src="/assets/images/attachment.png"
                            alt="attachment"
                            className="me-2"
                          />
                          Attach or drag file to upload
                        </button>
                      </div>
                      <div className="leadcontent">
                        <>
                          <div className="row">
                            <div className="col-12 col-md-12">
                              <div className="tableContainer">
                                <table>
                                  <thead>
                                    <tr>
                                      <th width="30%">File Name</th>
                                      <th width="20%">Attached By </th>
                                      <th width="21%">Date Added</th>
                                      <th width="21%">Size </th>
                                      <th width="8%">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>Screenshot-2024-08-09 12345.jpeg</td>
                                      <td>John Doe</td>
                                      <td>Sep 27, 2024 3:016 PM</td>
                                      <td>405.23 KB</td>
                                      <td>
                                        <div className="actionButton">
                                          <img
                                            src="/assets/images/eye.png"
                                            alt="View"
                                            width="18px"
                                          />
                                          <img
                                            src="/assets/images/editNotes.png"
                                            alt="Edit"
                                            width="14px"
                                          />
                                          <img
                                            src="/assets/images/deleteNotes.png"
                                            alt="Delete"
                                            width="18px"
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>

                    <div id="campaigns" className="scrollTo"></div>
                    <div className="addleadcard">
                      <div className="addlead-header">
                        <label htmlFor="">Campaigns</label>
                        <button type="button" className="btn btn-outline-primary attBtn">
                          Add Campaigns
                        </button>
                      </div>
                      <div className="leadcontent">
                        <>
                          <div className="row">
                            <div className="col-12 col-md-12">
                              <div className="tableContainer">
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Campaign Name</th>
                                      <th>Status</th>
                                      <th>Type</th>
                                      <th>Start Date </th>
                                      <th>End Date</th>
                                      <th>Expected Revenue</th>
                                      <th>Budgeted Cost</th>
                                      <th width="8%">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>Ad-Event-1</td>
                                      <td className="statusCol">
                                        <div className="active gr">
                                          <span className="dotsactive"></span>
                                          <a href="/crm">Active</a>
                                        </div>
                                      </td>
                                      <td>Conference</td>
                                      <td>Sep27,2022</td>
                                      <td>Nov 20, 2024</td>
                                      <td>$ 50,000.00</td>
                                      <td>$ 4,500.00</td>
                                      <td>
                                        <div className="actionButton">
                                          <img
                                            src="/assets/images/eye.png"
                                            alt="View"
                                            width="18px"
                                          />
                                          <img
                                            src="/assets/images/editNotes.png"
                                            alt="Edit"
                                            width="14px"
                                          />
                                          <img
                                            src="/assets/images/deleteNotes.png"
                                            alt="Delete"
                                            width="18px"
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Ad-Event-1</td>
                                      <td className="statusCol">
                                        <div className="active rd">
                                          <span className="holddots"></span>
                                          <a href="/crm">On Hold</a>
                                        </div>
                                      </td>
                                      <td>Conference</td>
                                      <td>Sep27,2022</td>
                                      <td>Nov 20, 2024</td>
                                      <td>$ 50,000.00</td>
                                      <td>$ 4,500.00</td>
                                      <td>
                                        <div className="actionButton">
                                          <img
                                            src="/assets/images/eye.png"
                                            alt="View"
                                            width="18px"
                                          />
                                          <img
                                            src="/assets/images/editNotes.png"
                                            alt="Edit"
                                            width="14px"
                                          />
                                          <img
                                            src="/assets/images/deleteNotes.png"
                                            alt="Delete"
                                            width="18px"
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>

                    <div id="openActivities" className="scrollTo"></div>
                    <div className="addleadcard">
                      <div className="addlead-header">
                        <label htmlFor="">Open Activities</label>
                        <div className="dropdown">
                          <button
                            className="btn btn-outline-primary dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            Add New
                          </button>
                          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li>
                              <a className="dropdown-item" href="#action">
                                Task
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#action">
                                Meeting
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#action">
                                Call
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="leadcontent">
                        <>
                          <div className="row g-0">
                            <div className="col-12 col-sm-12 col-md-4">
                              <div className="activityBlock">
                                <div className="activityHeader">
                                  <img
                                    src="/assets/images/member-list.png"
                                    alt="Open Task"
                                    width="21px"
                                    height="21px"
                                  />
                                  <p>Open Task</p> <span className="labelTask">1</span>
                                </div>
                                <div className="activityBody">
                                  <div className="activityContent">
                                    <div className="activityRow mb-2">
                                      <div className="flex-div">
                                        <img
                                          src="/assets/images/checkCircle.png"
                                          alt="Follow up Reminder"
                                          className="me-2"
                                          width="16px"
                                          height="16px"
                                        />
                                        <div className="flp">
                                          <p>Follow up Reminder</p>
                                          <small className="dateB">Sept 28,2024</small>
                                        </div>
                                      </div>

                                      <div className="actionButton flex-div">
                                        <img
                                          src="/assets/images/editNotes.png"
                                          alt="Edit"
                                          width="13px"
                                          height="13px"
                                        />
                                        <img
                                          src="/assets/images/deleteNotes.png"
                                          alt="Delete"
                                          width="14px"
                                          height="15px"
                                        />
                                      </div>
                                    </div>
                                    <div className="activityRow2">
                                      <img
                                        src="/assets/images/userImageSmall.png"
                                        alt=""
                                        className="me-2"
                                      />
                                      <div className="userActivity">
                                        <span>John Doe</span>
                                      </div>
                                    </div>
                                    <div className="otherInfo">
                                      <div className="otherInfoRow">
                                        <label>Status</label>{' '}
                                        <span className="TextValue">Not Started</span>
                                      </div>
                                      <div className="otherInfoRow">
                                        <label>Priority</label>

                                        <span className="TextValue High">High</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 col-md-4">
                              <div className="activityBlock whiteb">
                                <div className="activityHeader">
                                  <img
                                    src="/assets/images/openMeeting.png"
                                    alt="Open Meetings"
                                    width="21px"
                                    height="21px"
                                  />
                                  <p>Open Meetings</p> <span className="labelTask">1</span>
                                </div>
                                <div className="activityBody">
                                  <div className="activityContent">
                                    <div className="activityRow mb-2">
                                      <div className="flex-div">
                                        <img
                                          src="/assets/images/checkCircle.png"
                                          alt="Follow up Reminder"
                                          className="me-2"
                                          width="16px"
                                          height="16px"
                                        />
                                        <div className="flp">
                                          <p>New Meeting</p>
                                          <small className="dateB">
                                            Oct 17,2024 07:00 PM - 07:30 PM
                                          </small>
                                        </div>
                                      </div>

                                      <div className="actionButton flex-div">
                                        <img
                                          src="/assets/images/editNotes.png"
                                          alt="Edit"
                                          width="13px"
                                          height="13px"
                                        />
                                        <img
                                          src="/assets/images/deleteNotes.png"
                                          alt="Delete"
                                          width="14px"
                                          height="15px"
                                        />
                                      </div>
                                    </div>
                                    <div className="activityRow2">
                                      <img
                                        src="/assets/images/userImageSmall.png"
                                        alt=""
                                        className="me-2"
                                      />
                                      <div className="userActivity">
                                        <span>John Doe</span>
                                      </div>
                                    </div>
                                    <div className="otherInfo">
                                      <div className="otherInfoRow">
                                        <label>Priority</label>

                                        <span className="TextValue High">High</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 col-md-4">
                              <div className="activityBlock">
                                <div className="activityHeader">
                                  <img
                                    src="/assets/images/opencalls.png"
                                    alt="Open Task"
                                    width="26px"
                                    height="16px"
                                  />
                                  <p>Open Calls</p> <span className="labelTask">1</span>
                                </div>
                                <div className="activityBody">
                                  <div className="activityContent">
                                    <div className="activityRow mb-2">
                                      <div className="flex-div">
                                        <img
                                          src="/assets/images/checkCircle.png"
                                          alt="Follow up Reminder"
                                          className="me-2"
                                          width="16px"
                                          height="16px"
                                        />
                                        <div className="flp">
                                          <p>Call Scheduled with Ms. Carissa Kidman</p>
                                          <small className="dateB">
                                            Oct 17,2024 07:00 PM - 07:30 PM
                                          </small>
                                        </div>
                                      </div>

                                      <div className="actionButton flex-div">
                                        <img
                                          src="/assets/images/refresh3.png"
                                          alt="Refresh"
                                          width="14px"
                                          height="14px"
                                        />
                                        <img
                                          src="/assets/images/editNotes.png"
                                          alt="Edit"
                                          width="13px"
                                          height="13px"
                                        />
                                        <img
                                          src="/assets/images/deleteNotes.png"
                                          alt="Delete"
                                          width="14px"
                                          height="15px"
                                        />
                                      </div>
                                    </div>
                                    <div className="activityRow2">
                                      <img
                                        src="/assets/images/userImageSmall.png"
                                        alt=""
                                        className="me-2"
                                      />
                                      <div className="userActivity">
                                        <span>John Doe</span>
                                      </div>
                                    </div>
                                    <div className="otherInfo">
                                      <div className="otherInfoRow">
                                        <label>Priority</label>

                                        <span className="TextValue High">High</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>

                    <div id="closedActivities" className="scrollTo"></div>
                    <div className="addleadcard">
                      <div className="addlead-header">
                        <label htmlFor="">Closed Activities</label>
                      </div>
                      <div className="leadcontent">
                        <>
                          <div className="row g-0">
                            <div className="col-12 col-sm-12 col-md-4">
                              <div className="activityBlock">
                                <div className="activityHeader">
                                  <img
                                    src="/assets/images/member-list.png"
                                    alt="Close Task"
                                    width="21px"
                                    height="21px"
                                  />
                                  <p>Closed Task</p> <span className="labelTask disable">1</span>
                                </div>
                                <div className="activityBody">
                                  <div className="activityContent">
                                    <p>No Record Found</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 col-md-4">
                              <div className="activityBlock whiteb">
                                <div className="activityHeader">
                                  <img
                                    src="/assets/images/openMeeting.png"
                                    alt="Close Meetings"
                                    width="21px"
                                    height="21px"
                                  />
                                  <p>Closed Meetings</p> <span className="labelTask">1</span>
                                </div>
                                <div className="activityBody">
                                  <div className="activityContent">
                                    <div className="activityRow mb-2">
                                      <div className="flex-div">
                                        <img
                                          src="/assets/images/checkCircle.png"
                                          alt="Follow up Reminder"
                                          className="me-2"
                                          width="16px"
                                          height="16px"
                                        />
                                        <div className="flp">
                                          <p>New Meeting</p>
                                          <small className="dateB">
                                            Oct 17,2024 07:00 PM - 07:30 PM
                                          </small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 col-md-4">
                              <div className="activityBlock">
                                <div className="activityHeader">
                                  <img
                                    src="/assets/images/opencalls.png"
                                    alt="Open Task"
                                    width="26px"
                                    height="16px"
                                  />
                                  <p>Closed Calls</p> <span className="labelTask">1</span>
                                </div>
                                <div className="activityBody">
                                  <div className="activityContent">
                                    <div className="activityRow mb-2">
                                      <div className="flex-div">
                                        <img
                                          src="/assets/images/checkCircle.png"
                                          alt="Follow up Reminder"
                                          className="me-2"
                                          width="16px"
                                          height="16px"
                                        />
                                        <div className="flp">
                                          <p>Call Scheduled with Ms. Carissa Kidman</p>
                                          <small className="dateB">
                                            Oct 17,2024 07:00 PM - 07:30 PM
                                          </small>
                                        </div>
                                      </div>

                                      <div className="actionButton flex-div">
                                        <img
                                          src="/assets/images/refresh3.png"
                                          alt="Refresh"
                                          width="14px"
                                          height="14px"
                                        />
                                        <img
                                          src="/assets/images/editNotes.png"
                                          alt="Edit"
                                          width="13px"
                                          height="13px"
                                        />
                                        <img
                                          src="/assets/images/deleteNotes.png"
                                          alt="Delete"
                                          width="14px"
                                          height="15px"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>

                    <div id="invitedMeetings" className="scrollTo"></div>
                    <div className="addleadcard">
                      <div className="addlead-header">
                        <label htmlFor="">Invited Meetings</label>
                      </div>
                      <div className="leadcontent">
                        <>
                          <div className="row">
                            <div className="col-12 col-md-12">
                              <div className="tableContainer">
                                <table>
                                  <thead>
                                    <tr>
                                      <th width="30%">Title</th>
                                      <th>Meeting Date</th>
                                      <th>Status</th>

                                      <th width="8%">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>Carissa Meeting</td>
                                      <td>Sep 27, 2024 3:016 PM</td>
                                      <td>No response</td>

                                      <td>
                                        <div className="actionButton">
                                          <img
                                            src="/assets/images/eye.png"
                                            alt="View"
                                            width="18px"
                                          />
                                          <img
                                            src="/assets/images/editNotes.png"
                                            alt="Edit"
                                            width="14px"
                                          />
                                          <img
                                            src="/assets/images/deleteNotes.png"
                                            alt="Delete"
                                            width="18px"
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Carissa Meeting - 2</td>
                                      <td>Sep 27, 2024 3:016 PM</td>
                                      <td>No response</td>

                                      <td>
                                        <div className="actionButton">
                                          <img
                                            src="/assets/images/eye.png"
                                            alt="View"
                                            width="18px"
                                          />
                                          <img
                                            src="/assets/images/editNotes.png"
                                            alt="Edit"
                                            width="14px"
                                          />
                                          <img
                                            src="/assets/images/deleteNotes.png"
                                            alt="Delete"
                                            width="18px"
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>
                    <div id="emails" className="scrollTo"></div>
                    <div className="addleadcard">
                      <div className="addlead-header">
                        <label htmlFor="">Emails</label>
                        <button className="btn btn-outline-primary attBtn">Compose Email</button>
                      </div>
                      <div className="emialTabRow">
                        <ul className="nav nav-tabs justify-content-start">
                          <li className="nav-item">
                            <a className="nav-link active" href="#tab1" data-bs-toggle="tab">
                              Emails Sent
                            </a>
                          </li>
                          <li className="nav-item">
                            <a className="nav-link" href="#tab2" data-bs-toggle="tab">
                              Draft
                            </a>
                          </li>
                          <li className="nav-item">
                            <a className="nav-link" href="#tab3" data-bs-toggle="tab">
                              Scheduled
                            </a>
                          </li>
                        </ul>
                      </div>

                      <div className="leadcontent">
                        <>
                          <div className="row">
                            <div className="col-12 col-md-12">
                              <div className="tab-content">
                                <div className="tab-pane fade show active" id="tab1">
                                  <div className="tableContainer">
                                    <table>
                                      <thead>
                                        <tr>
                                          <th>
                                            <input type="checkbox" />
                                          </th>
                                          <th width="27.5%">Campaign Name</th>
                                          <th>Status</th>
                                          <th>Source</th>
                                          <th>Date</th>
                                          <th>Sent By</th>

                                          <th width="8%">Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <input type="checkbox" />
                                          </td>
                                          <td className="cName">
                                            <p>Product Newsletter</p>
                                            <a href="mailto:carlssa-kidman@mail.com" title="">
                                              <span className="mailLink">
                                                carlssa-kidman@mail.com
                                              </span>
                                            </a>
                                          </td>
                                          <td>Recieved</td>
                                          <td>Mass Email</td>
                                          <td>Sep27,2022</td>
                                          <td>Nov 20, 2024</td>
                                          <td>
                                            <div className="actionButton">
                                              <img
                                                src="/assets/images/eye.png"
                                                alt="View"
                                                width="18px"
                                              />
                                              <img
                                                src="/assets/images/editNotes.png"
                                                alt="Edit"
                                                width="14px"
                                              />
                                              <img
                                                src="/assets/images/deleteNotes.png"
                                                alt="Delete"
                                                width="18px"
                                              />
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                                <div className="tab-pane fade" id="tab2">
                                  <div className="tableContainer">
                                    <table>
                                      <thead>
                                        <tr>
                                          <th>
                                            <input type="checkbox" />
                                          </th>
                                          <th width="27.5%">Subject</th>

                                          <th>Content</th>
                                          <th>Date</th>
                                          <th>From Address</th>

                                          <th width="8%">Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <input type="checkbox" />
                                          </td>
                                          <td className="cName">
                                            <p>Product Newsletter</p>
                                            <a href="mailto:carlssa-kidman@mail.com" title="">
                                              <span className="mailLink">
                                                carlssa-kidman@mail.com
                                              </span>
                                            </a>
                                          </td>

                                          <td>Mass Email</td>
                                          <td>Sep27,2022</td>
                                          <td>
                                            {' '}
                                            <a href="mailto:carlssa-kidman@mail.com" title="">
                                              <span className="mailLink">
                                                carlssa-kidman@mail.com
                                              </span>
                                            </a>
                                          </td>
                                          <td>
                                            <div className="actionButton">
                                              <img
                                                src="/assets/images/eye.png"
                                                alt="View"
                                                width="18px"
                                              />
                                              <img
                                                src="/assets/images/editNotes.png"
                                                alt="Edit"
                                                width="14px"
                                              />
                                              <img
                                                src="/assets/images/deleteNotes.png"
                                                alt="Delete"
                                                width="18px"
                                              />
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                                <div className="tab-pane fade" id="tab3">
                                  <div className="tableContainer">
                                    <table>
                                      <thead>
                                        <tr>
                                          <th>
                                            <input type="checkbox" />
                                          </th>
                                          <th width="27.5%">Subject</th>

                                          <th>Source</th>
                                          <th>Date</th>
                                          <th>Sent By</th>

                                          <th width="8%">Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <input type="checkbox" />
                                          </td>
                                          <td className="cName">
                                            <p>Product Newsletter</p>
                                            <a href="mailto:carlssa-kidman@mail.com" title="">
                                              <span className="mailLink">
                                                carlssa-kidman@mail.com
                                              </span>
                                            </a>
                                          </td>

                                          <td>Mass Email</td>
                                          <td>Sep27,2022</td>
                                          <td>Jack Smith</td>
                                          <td>
                                            <div className="actionButton">
                                              <img
                                                src="/assets/images/eye.png"
                                                alt="View"
                                                width="18px"
                                              />
                                              <img
                                                src="/assets/images/editNotes.png"
                                                alt="Edit"
                                                width="14px"
                                              />
                                              <img
                                                src="/assets/images/deleteNotes.png"
                                                alt="Delete"
                                                width="18px"
                                              />
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="timeline">
                    <div className="addleadcard">
                      <div className="addlead-header">
                        <label htmlFor="">TimeLine</label>
                      </div>
                      <div className="leadcontent">
                        <>
                          <div className="row">
                            <div className="col-12 col-sm-12 col-md-12">
                              <div className="Timeline_CRM">
                                <div className="audit-header">
                                  <label>Timeline History</label>

                                  <span className="calendar-icon">
                                    <img src="/assets/images/calendar-2.png" alt="" width="15px" />
                                  </span>
                                </div>

                                <div className="audit-date">04/11/2024</div>

                                <div className="audit-timeline">
                                  <div className="timeline-item">
                                    <div className="timeline-line"></div>
                                    <div className="timeline-dot">
                                      <img src="/assets/images/laptop.svg" alt="" width="16px" />
                                    </div>
                                    <div className="time">08:01 PM</div>
                                    <div className="userNameBlock">
                                      <p className="user-name">Brandon M. Ericson</p>
                                      <span className="action">Nov 25, 2024</span>
                                    </div>
                                  </div>

                                  <div className="timeline-item">
                                    <div className="timeline-line"></div>
                                    <div className="timeline-dot">
                                      <img src="/assets/images/laptop.svg" alt="" width="16px" />
                                    </div>
                                    <div className="time">11:09 AM</div>
                                    <div className="userNameBlock">
                                      <p className="user-name">Donna D. Lynch</p>
                                      <span className="action">Nov 20, 2024</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCalls;
